import { getAppUrl } from '@drayalliance/utils';

export default function createLoginRedirectURL(fromService = null) {
  let result = getAppUrl(window.location.hostname, 'accounts', 9002);

  result += `?service=${fromService}&continue=${encodeURIComponent(window.location.href)}`;

  return result;
}
